import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
// import Gallery from './components/Gallery';
import Education from './components/Education';
import Certifications from './components/Certifications';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingIconsBackground from './components/FloatingIconsBackground';

const App = () => {
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <div className="bg-navy dark:bg-gray-900 min-h-screen font-sans transition-colors duration-500 relative overflow-hidden">
      {/* 👇 Floating background icons */}
      <FloatingIconsBackground />

      <Header darkMode={darkMode} setDarkMode={setDarkMode} />
      <main className="relative z-10 max-w-5xl mx-auto px-4">
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Projects />
        {/* <Gallery /> */}
        <Education />
        <Certifications />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default App;
